import { InputType } from "../components/sop/inputPanel";

export const formFields = {
  endpoint: "loracademic",
  inputs: [
    {
      name: "student_name",
      label: "Name of the student",
      placeholder: "Kritika Chopra",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
    },
    {
      name: "skills",
      label: "Skills",
      placeholder: "Creative and innovative ideas,Teamwork ",
      type: InputType.CountedTextArea,
      minLength: 2,
      maxLength: 200,
    },
    {
      name: "strengths",
      label: "Strengths",
      placeholder: "time management, creativity, and dedication",
      type: InputType.CountedTextArea,
      minLength: 2,
      maxLength: 250,
    },
    {
      name: "qualities",
      label: "Qualities",
      placeholder: "Highly motivated, responsible, and strong work ethic",
      type: InputType.CountedTextArea,
      minLength: 2,
      maxLength: 250,
    },
    {
      name: "time_period",
      label: "Time Period",
      placeholder: "10 years",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
    },
  ],
};

export default formFields;
